import type { ReactNode } from 'react';
import {
    NotificationAssigneeCell,
    type AssignablePatient
} from '../notifications/NotificationAssigneeCell';
import {
    TriageFrustrationControl,
    TriagePriorityControl,
    type TriageControlsValue
} from './triage/TriageControls';

interface DmMessagePanelFieldsProps {
    patient: AssignablePatient;
    triage: TriageControlsValue;
}

function StackedField({ title, children }: { title: string; children: ReactNode }) {
    return (
        <div className="flex min-w-0 flex-col gap-1.5">
            <span className="text-xs font-medium text-gray-500">{title}</span>
            <div>{children}</div>
        </div>
    );
}

// The patient's editable fields; assignment and triage are per patient, so both lists refresh.
export function DmMessagePanelFields({ patient, triage }: DmMessagePanelFieldsProps) {
    const { patientId } = patient;
    return (
        <div className="grid grid-cols-3 gap-4">
            <StackedField title="Assignee">
                <NotificationAssigneeCell row={patient} dropUp={false} align="left" />
            </StackedField>
            <StackedField title="Priority">
                <TriagePriorityControl patientId={patientId} triage={triage} align="left" />
            </StackedField>
            <StackedField title="Frustration">
                <TriageFrustrationControl patientId={patientId} triage={triage} align="right" />
            </StackedField>
        </div>
    );
}
